import styled, { css, keyframes } from 'styled-components';
import { media } from '@cld/style-utils';
import theme from '@cld/theme-helper';

const fadeIn = keyframes`
  from {
    transform: translate(0,-100%)
  }

  to {
    transform: translate(0,0)
  }
`;

const ModalBox = styled.div`
  border-radius: ${theme`components.modal.border.radius`};
  overflow: hidden;
  position: relative;
  min-width: 520px;
  min-height: 235px;
  background-color: #ffffff;
  max-width: calc(100vw - 60px);
  max-height: calc(100vh - 60px);
  box-shadow: 0 2px 23px 7px rgba(0, 0, 0, 0.29);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  outline: 0;
  transform: ${(props) => `translate(0,${!props.isOpen ? '-100%' : '0'})`};
  transition: ${(props) => `transform ease-in ${props.delay}ms`};
  animation: ${(props) =>
    css`
      ${fadeIn} ${props.delay}ms ease-out;
    `};
  @media ${media.phone} {
    width: 280px;
    min-height: 261px;
    max-height: 389px;
  }
`;

export default ModalBox;
